import React from "react";
import "./Ticker.css";

const items = [
  "Instant Cash",
  "Transparent Valuation",
  "Maximum Value",
  "100% Safe",
  "Statutory Compliant",
];

export default function Ticker() {
  // Render the list twice so the loop can scroll seamlessly
  const renderItems = (keyPrefix) =>
    items.map((item, i) => (
      <React.Fragment key={`${keyPrefix}-${i}`}>
        <span className="ticker__item">{item}</span>
        <span className="ticker__dot">✦</span>
      </React.Fragment>
    ));

  return (
    <div className="ticker">
      <div className="ticker__track">
        <div className="ticker__group">{renderItems("a")}</div>
        <div className="ticker__group">{renderItems("b")}</div>
      </div>
    </div>
  );
}